var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1573_275)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 18,
    height: 18,
    rx: 3,
    stroke: "#B9B9C3",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 5,
    width: 12,
    height: 2,
    rx: 1,
    fill: "#B9B9C3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 9,
    width: 12,
    height: 2,
    rx: 1,
    fill: "#B9B9C3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 13,
    width: 12,
    height: 2,
    rx: 1,
    fill: "#B9B9C3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1573_275"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewIcon);
export default __webpack_public_path__ + "static/media/ViewIcon.a952a9a7.svg";
export { ForwardRef as ReactComponent };